<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="房间号">
        <el-input v-model="form.roomUuid"></el-input>
      </el-form-item>
      <el-form-item label="课程类型">
        <el-select v-model="form.roomType" placeholder="请选择课程类型">
          <el-option label="小课班" value=4></el-option>
          <el-option label="大课班" value=2></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="form.userUuid"></el-input>
      </el-form-item>
      <el-form-item label="用户昵称">
        <el-input v-model="form.userName"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="form.role" placeholder="请选择角色">
          <el-option label="老师" value=1></el-option>
          <el-option label="学生" value=2></el-option>
          <el-option label="助教" value=3></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">加入房间</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {joinLive} from "@/api/live";
import {getRoom, getUser} from "@/api/shengwangLive";

export default {
  data() {
    return {
      form: {
        roomType: "2",
        roomUuid: "",
        userUuid: "",
        role: "2"
      }
    }
  },

  methods: {
    onUserDetail() {
      getUser(this.form.roomUuid, this.form.userUuid).then(res => {
        console.log(res)
      })
    },
    onDetail() {
      getRoom(this.form.roomUuid).then(res => {
        console.log(res)
      })
    },
    onSubmit() {
      const formData = {
        roomType: this.form.roomType,
        roomUuid: this.form.roomUuid,
        userUuid: this.form.userUuid,
        userName: this.form.userName,
        role: this.form.role,
        roomToken: "",
        userToken: "007eJxTYJj8esfTGeb9cXKL1/is8v93NoEntDMp7+wTs/s2PsuqdCoVGEzMDC1MkkyMLZONzU0MDZItUgzTEs0MDI0NLSwMjAyNLGW9MgX4GBii55W7MDMwMTACIYjPzGBoZMzKwMCgwGBkYJScZGlmlJhsamlgbgpkmiQZmBuaGqUYGZskmRuwwzUJMgTl5+fGJ5oZm5lZppknmlsagc1hYgAAAikp5A=="
      };
      // 将数据保存到 localStorage（或者 sessionStorage）
      localStorage.setItem('liveBroadcastData', JSON.stringify(formData));
      // 跳转到目标页面
      window.location.href = '/liveBroadcast.html';
      // this.$router.push({"path": "/liveLook"});
      /*joinLive(this.form).then(res => {
        if (res.code === 200) {
          const formData = {
            roomType: this.form.roomType,
            roomUuid: this.form.roomUuid,
            userUuid: this.form.userUuid,
            userName: this.form.userName,
            role: this.form.role,
            roomToken: res.data.roomToken,
            userToken: res.data.token
          };
          // 将数据保存到 localStorage（或者 sessionStorage）
          localStorage.setItem('liveBroadcastData', JSON.stringify(formData));
          // 跳转到目标页面
          // window.location.href = '/liveBroadcast.html';
          this.$router.push({"path": "/liveLook"});
        }
      })*/
    }
  }
}
</script>
<style scoped>

</style>
